import React from 'react'
import { injectIntl } from 'react-intl'
import { Image, Transformation } from 'cloudinary-react'
import { Box } from '@material-ui/core'
import { useStyles } from '../TechlinkCompanyShow_style'
import RouteMap from 'assets/RouteMap.js'
import ShareAction from 'components/ShareAction/ShareAction'
import { optimiseSizeForMobile, EXTRA_LARGE_SIZE } from 'assets/CloudinaryURLHelper'

const TechlinkCompanyBanner = (props) => {
    const classes = useStyles()
    const { company, editPage } = props
    const { formatMessage } = props.intl

    return (
        <Box className={classes.bannerContainer}>
            <Box className={classes.shareButton}>
                <ShareAction
                    infos={{
                        title: company.name,
                        url: RouteMap.Show('company', company.url),
                        type: 'company'
                    }}
                />
            </Box>
            <Image
                alt={formatMessage({ id: 'company_profile.banner.image_alt' }, { company_name: company.name })}
                cloudName="studentbe"
                publicId={company.banner_image_cloudinary_key}
                className={editPage ? classes.addBannerCTA : ''}
            >
                <Transformation
                    flags="progressive"
                    fetchFormat="auto"
                    width={optimiseSizeForMobile(EXTRA_LARGE_SIZE)}
                    quality="auto:best"
                    crop="fill"
                />
            </Image>
        </Box>
    )
}

export default injectIntl(TechlinkCompanyBanner)
